import { render, staticRenderFns } from "./select-moodle-course-modal.vue?vue&type=template&id=c51d519a&scoped=true"
import script from "./select-moodle-course-modal.vue?vue&type=script&lang=js"
export * from "./select-moodle-course-modal.vue?vue&type=script&lang=js"
import style0 from "./select-moodle-course-modal.vue?vue&type=style&index=0&id=c51d519a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51d519a",
  null
  
)

export default component.exports